export function capitalize(str) {
    return str
		.split(" ")
		.map(word =>
			word.length > 0
			? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
			: ""
		)
		.join(" ");
  }

export const formatWithCommas = (num) => {
	const numStr = String(num); // <-- safely ensure it's a string
	const number = Number(numStr.replace(/,/g, ""));
	if (isNaN(number)) return "";
	return new Intl.NumberFormat().format(number);
};
